<template>
    <div v-if="customerDetails != null">
        <div class="md-layout">
            <div class="md-layout-item">
                <div class="custom-toolbar">
                    <div class="custom-toolbar-start">
                        <h3 class="title">
                            {{ customerDetails.name }}
                        </h3>
                    </div>
                </div>
            </div>
        </div>
        <div class="md-layout md-alignment-top-left content-layout-panel">
            <div
                class="md-layout-item md-small-size-100 md-medium-size-100 md-layout md-large-size-66 md-xlarge-size-50"
            >
                <div class="md-layout-item md-large-size-100 md-medium-size-100 md-small-size-100 md-xlarge-size-100">
                    <md-card>
                        <md-card-header class="md-card-header-icon md-card-header-green">
                            <div class="card-icon">
                                <md-icon>description</md-icon>
                            </div>
                        </md-card-header>

                        <md-card-content>
                            <div class="flex-container">
                                <div class="details-box">
                                    <label>ABN</label>
                                    <span class="value">
                                        {{ customerDetails.businessRegistrationNumber }}
                                    </span>
                                </div>

                                <div class="details-box">
                                    <label>Company</label>
                                    <span class="value">
                                        {{ customerDetails.company }}
                                    </span>
                                </div>

                                <div class="details-box">
                                    <label>First name</label>
                                    <span class="value">
                                        {{ customerDetails.firstName }}
                                    </span>
                                </div>

                                <div class="details-box">
                                    <label>Last name</label>
                                    <span class="value">
                                        {{ customerDetails.lastName }}
                                    </span>
                                </div>
                            </div>

                            <div class="details-box">
                                <label>Address</label>
                                <span class="value">
                                    {{ customerDetails.address }}
                                </span>
                            </div>

                            <div class="flex-container">
                                <div class="details-box">
                                    <label>Phone</label>
                                    <span class="value">
                                        {{ customerDetails.phone }}
                                    </span>
                                </div>

                                <div class="details-box">
                                    <label>Email</label>
                                    <span class="value">
                                        {{ customerDetails.email }}
                                    </span>
                                </div>

                                <div class="details-box">
                                    <label>Contact Email</label>
                                    <span class="value">
                                        {{ customerDetails.contactEmail }}
                                    </span>
                                </div>
                            </div>

                            <div class="details-box">
                                <label>Default Stop Notes</label>
                                <span class="value">
                                    {{ customerDetails.defaultStopNotes }}
                                </span>
                            </div>

                            <div class="details-box">
                                <label>Payment Terms (Days)</label>
                                <span class="value">
                                    {{ customerDetails.paymentTermsInDays }}
                                </span>
                            </div>
                        </md-card-content>
                    </md-card>
                </div>

                <div class="md-layout-item md-small-size-100 md-large-size-100 md-xlarge-size-100">
                    <notes
                        :list="customerDetails.latestNotes"
                        :customer-id="customerDetails.customerId"
                        @notesAdded="handleAddedStopNote"
                    />
                </div>
            </div>

            <div
                class="md-layout-item md-small-size-100 md-medium-size-100 md-layout md-large-size-66 md-xlarge-size-50"
            >
                <md-card>
                    <md-card-header class="md-card-header-icon md-card-header-blue">
                        <div class="card-icon">
                            <md-icon>directions_bus</md-icon>
                        </div>
                    </md-card-header>
                    <md-card-content>
                        <md-table v-if="!$root.isMobileOnly">
                            <md-table-row>
                                <md-table-head>Stop Ref</md-table-head>
                                <md-table-head>Status</md-table-head>
                                <md-table-head>Trip date</md-table-head>
                                <md-table-head>Address</md-table-head>
                            </md-table-row>
                            <md-table-row v-for="stop in customerDetails.lastVisitedStops" :key="stop.stopId">
                                <md-table-cell>
                                    <router-link
                                        class="normal-link"
                                        :to="{
                                            name: 'Stop Details',
                                            params: { stopId: stop.stopId }
                                        }"
                                    >
                                        {{ stop.stopRef }}
                                    </router-link>
                                </md-table-cell>
                                <md-table-cell>
                                    <span
                                        class="custom-badge"
                                        :class="`status-${stop.status.replace(/\s/g, '').toLowerCase()}`"
                                    >
                                        {{ stop.status }}
                                    </span>
                                </md-table-cell>
                                <md-table-cell>
                                    {{ stop.tripDate | dateFormat(DATE_TYPES.standardDate) }}
                                </md-table-cell>
                                <md-table-cell>
                                    {{ stop.addressComponents != null ? stop.addressComponents.address : stop.address }}
                                </md-table-cell>
                            </md-table-row>
                        </md-table>
                        <div v-else>
                            <div class="mobile-stop-info">
                                <div
                                    v-for="stop in customerDetails.lastVisitedStops"
                                    :key="stop.stopId"
                                    class="stop-info"
                                >
                                    <div>
                                        <strong>Stop Ref:</strong>
                                        <router-link
                                            class="normal-link"
                                            :to="{
                                                name: 'Stop Details',
                                                params: { stopId: stop.stopId }
                                            }"
                                        >
                                            {{ stop.stopRef }}
                                        </router-link>
                                    </div>
                                    <div>
                                        <strong>Status:</strong>
                                        <span
                                            class="custom-badge"
                                            :class="`status-${stop.status.replace(/\s/g, '').toLowerCase()}`"
                                        >
                                            {{ stop.status }}
                                        </span>
                                    </div>
                                    <div>
                                        <strong>Trip Date:</strong>
                                        {{ stop.tripDate | dateFormat(DATE_TYPES.standardDate) }}
                                    </div>
                                    <div>
                                        <strong>Address:</strong>
                                        {{
                                            stop.addressComponents != null
                                                ? stop.addressComponents.address
                                                : stop.address
                                        }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </md-card-content>
                </md-card>
            </div>
        </div>
    </div>
</template>

<script>
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { handleRequests, showErrorMessage } from '@/helpers';
import { Notes } from '@/components';

export default {
    name: 'CustomerDetails',
    mixins: [GeneralMixin],
    components: {
        Notes
    },
    data() {
        return {
            customerDetails: null
        };
    },
    async mounted() {
        this.$nextTick(async () => {
            await this.getCustomerDetails(this.$route.params.customerId);
        });
    },
    methods: {
        async getCustomerDetails(customerId) {
            try {
                this.$_handleLoaderState(true);
                const qry = new URLSearchParams();
                qry.append('includeStopsHistory', true);
                qry.append('includeNotes', true);
                qry.append('extendedDetails', true);

                const api = `/api/customers/${customerId}/?${qry}`;
                const { data } = await handleRequests(api);
                this.customerDetails = {};
                Object.assign(this.customerDetails, data);
            } catch (error) {
                const message = 'Error in getting the customer details';
                showErrorMessage(this, message, error);
            }

            this.$_handleLoaderState(false);
        },
        async handleAddedStopNote() {
            await this.getCustomerDetails(this.$route.params.customerId);
        }
    }
};
</script>

<style lang="scss" scoped>
.title {
    margin-top: 30px !important;
}
@media (min-width: 720px) {
    .title {
        margin-top: 0 !important;
    }
    .flex-container {
        display: flex;
        flex-wrap: wrap;
        > div {
            margin-right: 30px;
        }
        > div:last-child {
            margin-right: 0;
        }
    }
}

.mobile-stop-info {
    .stop-info {
        margin-bottom: 20px;
        border-bottom: 1px solid #e0e0e0;
        padding-bottom: 20px;
        > div {
            margin-bottom: 10px;
        }
    }
}

.normal-link {
    color: rgba(0, 0, 0, 0.87) !important;
}

.normal-link:hover {
    color: #2b93ff !important;
}

.custom-badge {
    min-width: 78px;
}
</style>
